import { FeatureFlag } from '../types';

import { locatorServiceAPI } from 'shared/services';

export const applicationAPI = {
  getFeatureFlags: () => locatorServiceAPI.get<{ featureFlags: FeatureFlag[] }>('feature-flags')
}
